import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';
import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import Text from '@/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';
import { useEffect } from 'react';
import { INSERT_ID, SCRIPT_ID } from './Answers';

type TAnswersProps = {
    title: string;
    url: string;
    id: string;
    image?: string;
};

const Wrapper = styled.div`
    width: 100%;
    max-width: 1124px;
    margin: 0 auto 20px;
    padding: 0 16px;

    ${Screen.ipad} {
        padding: 0 29px;
        margin: 0 auto 60px;
    }
    ${Screen.desktop} {
        padding: 0 30px;
    }
`;

const Container = styled.div`
    background-color: ${cssVars.bg_white_dark3};
    border-radius: ${radius.small};
    box-shadow: 0px 4px 23px ${cssVars.shadow_normal};
    margin-bottom: 10px;
    padding: 0 20px;
    overflow: hidden;
    position: relative;

    ${Screen.ipad} {
        margin-bottom: 16px;
        padding: 0 30px;
    }
    ${Screen.desktop} {
        margin-bottom: 10px;
        max-width: 1064px;
    }

    .answerbase-widget {
        color: ${cssVars.fg_gray1_white} !important;
        margin-bottom: 60px !important;
    }

    .answerbase-widget h5 {
        ${Text.Full.large.semibold}
    }

    .vote-down img,
    .vote-up img {
        border-radius: 4px;
    }

    .avatar,
    input {
        border-radius: 20px !important;
    }

    input {
        padding-left: 16px !important;
        background-color: transparent !important;
        color: ${cssVars.fg_gray1_white} !important;
    }

    #ab_ask {
        border-radius: 20px !important;
        background: linear-gradient(90deg, #03d9b1 0%, #1cbbd9 100%) !important;
        padding-left: 24px !important;
        padding-right: 24px !important;
    }

    .type {
        color: ${Palette.green.normal} !important;
    }
`;

const Title = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading2}
    padding: 17px 0;

    ${Screen.desktop} {
        padding: 22px 0;
    }
`;

const removeAllElements = () => {
    document.querySelector(`.answerbase-widget`)?.remove?.();
    document.querySelectorAll('script[src], link[href]')?.forEach((el) => {
        try {
            const url =
                el instanceof HTMLScriptElement
                    ? el.src
                    : el instanceof HTMLLinkElement
                    ? el.href
                    : null;

            if (!url) return;

            if (new URL(url).hostname.includes('answerbase.com')) {
                el?.remove?.();
            }
        } catch (e) {
            console.log('[ERROR] Failed to remove answerbase element!');
        }
    });
};

export const AnswersFAQ = ({ title, url, id, image }: TAnswersProps) => {
    useEffect(() => {
        removeAllElements();
        document.querySelector(`#${SCRIPT_ID}`)?.remove?.();

        const el = document.createElement('script');

        el.id = SCRIPT_ID;
        el.type = 'text/javascript';
        el.src =
            'https://tripshock.services.answerbase.com/javascript/widget/full-featured-widget.min.js';
        el.async = true;
        el.setAttribute('data-text-title', 'none');
        el.setAttribute('data-external-product-category-id', id);
        el.setAttribute('data-product-category-title', title);
        el.setAttribute('data-product-category-url', url);
        el.setAttribute('data-product-category-image', image || '');
        el.setAttribute('data-insert-after', `#${INSERT_ID}`);

        document.body.appendChild(el);
    }, [title, url, id, image]);

    return (
        <Wrapper>
            <Container>
                <Title id={INSERT_ID}>Frequently Asked Questions</Title>
            </Container>
        </Wrapper>
    );
};
